
const STORAGE_KEY = "produpneu_cart";

function loadCart() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const parsed = saved ? JSON.parse(saved) : [];

    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function saveCart(items) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );
  } catch (error) {
    console.warn("Cart storage unavailable:", error);
  }
}

export default {
  namespaced: true,

  state: () => ({
    items: loadCart(),
  }),

  getters: {
    cartCount(state) {
      return state.items.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );
    },

    subtotal(state) {
      return state.items.reduce(
        (total, item) =>
          total + Number(item.price || 0) *
          Number(item.quantity || 0),
        0
      );
    },
  },

  mutations: {
    ADD_ITEM(state, product) {
      const existing = state.items.find(
        item => String(item.id) === String(product.id)
      );

      if (existing) {
        existing.quantity += 1;
      } else {
        state.items.push({
          ...product,
          quantity: 1,
        });
      }

      saveCart(state.items);
    },

    REMOVE_ITEM(state, productId) {
      state.items = state.items.filter(
        item => String(item.id) !== String(productId)
      );

      saveCart(state.items);
    },

    UPDATE_QUANTITY(state, { id, quantity }) {
      const item = state.items.find(
        product => String(product.id) === String(id)
      );

      if (!item) return;

      item.quantity = Math.max(1, Number(quantity) || 1);
      saveCart(state.items);
    },

    CLEAR_CART(state) {
      state.items = [];
      saveCart(state.items);
    },
  },

  actions: {
    addItem({ commit }, product) {
      commit("ADD_ITEM", product);
    },

    removeItem({ commit }, id) {
      commit("REMOVE_ITEM", id);
    },

    updateQuantity({ commit }, payload) {
      commit("UPDATE_QUANTITY", payload);
    },

    clearCart({ commit }) {
      commit("CLEAR_CART");
    },
  },
};
